export default {
    data: () => ({
        setupLoading: false,
        setupLoaded: false,
        setupOnMounted: true,
        setupRestricted: false,
        afterSetupArgs: {}
    }),
    async mounted() {
        this.checkSetupRestrictions();

        if (this.setupOnMounted && !this.setupRestricted) {
            await this.trySetup();
        }
    },
    methods: {
        async trySetup(args) {
            if (this.setupRestricted) {
                return;
            }

            this.setupLoading = true;
            await this.setup(args);
            await this.afterSetup(this.afterSetupArgs);
            this.setupLoading = false;
            this.setupLoaded = true;
        },
        async setup() {},
        async afterSetup() {},
        checkSetupRestrictions() {
            this.setupRestricted = false;
        }
    }
    // watch: {
    //     setupRestricted(isNowRestricted) {
    //         if (!isNowRestricted && !this.setupLoaded) {
    //             this.trySetup();
    //         }
    //     }
    // }
};
